/** @format */

import React, { useState } from 'react'
import Modal from 'react-modal'
import TnCs from '../TnCs'
import { useGA4React } from 'ga-4-react'
import './style.css'

import { is_touch_device } from '../../utils'

export function HowToPlay(props) {
  const [tncsView, setTncsView] = useState(false)

  const ga = useGA4React()

  const openTncs = () => {
    setTncsView(!tncsView)
    ga.event('terms_&_conditions_click', 'Flavour Drop')
  }

  const infoModalClasses = {
    base: 'info-modal',
    afterOpen: 'info-modal--after-open',
    beforeClose: 'info-modal--before-close',
  }
  const infoModalOverlayClasses = {
    base: 'info-modal-overlay',
    afterOpen: 'info-modal-overlay--after-open',
    beforeClose: 'info-modal-overlay--before-close',
  }

  return (
    <>
      <div className="how-to-play">
        <h1 className="title">HOW TO PLAY</h1>

        {!is_touch_device() && (
          <>
            <h2 className="title">Move</h2>
            <p className="text">
              Tap the left/right arrow keys on your keyboard to move <br />
              the vuse device at the bottom of the screen.
            </p>
          </>
        )}

        {is_touch_device() && (
          <>
            <h2 className="title">Tilt</h2>
            <p className="text">
              Tilt your phone left and right to move <br /> the vuse device at
              the bottom of the <br className="mobile-only" />
              screen.
            </p>
          </>
        )}

        <h2 className="title">Catch</h2>
        <p className="text">
          CATCH 20 FLAVOUR DROPS BEFORE THE TIMER
          <br className="mobile-only" /> RUNS OUT TO GET
          <br className="desktop-only" /> A FREE PACK OF PODS*.
        </p>

        <h2 className="title">Save</h2>
        <p className="text">
          CATCH LESS THAN 20 FLAVOUR DROPS AND
          <br className="mobile-only" /> YOU CAN CHOOSE TO
          <br className="desktop-only" /> TRY AGAIN OR GET FREE
          <br className="mobile-only" /> DELIVERY ON YOUR NEXT PURCHASE*.
        </p>
        {/* <p className="text"> */}
        {/*   Catch less than 10 flavour drops and you will receive a code <br />{' '} */}
        {/*   for a free delivery. */}
        {/* </p> */}
        <button
          className="btn btn-primary"
          onClick={() => props.start()}
          style={{ margin: '80px auto 20px auto' }}
        >
          Play Now
        </button>
        <p
          className="text"
          onClick={() => openTncs()}
          style={{ cursor: 'pointer', textTransform: 'unset' }}
        >
          <strong>*T&Cs apply. Selected flavours only.</strong>
        </p>
      </div>

      {/* Terms & Conditions modal */}
      <Modal
        className={infoModalClasses}
        overlayClassName={infoModalOverlayClasses}
        isOpen={tncsView}
        onRequestClose={() => setTncsView(!tncsView)}
        closeTimeoutMS={500}
      >
        <button className="btn-close" onClick={() => setTncsView(!tncsView)}>
          &times;
        </button>
        <div className="modal-content">
          <TnCs />
        </div>
      </Modal>
    </>
  )
}
